import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { TMSService, TrackableView } from '@ecm/tracker';

import { Error } from '../../business/error';
import { ElcosService } from '../../services/elcos.service';
import { ErrorPageService, ErrorType } from '../../services/error-page.service';
import { RouterService } from '../../services/router.service';
import { TitleService } from '../../services/title.service';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'error',
    templateUrl: 'error.component.html',
})
export class ErrorComponent implements OnInit, TrackableView {
    public error = new Error();
    public errorType: string;
    public confirmationLabel: string;
    public canRetry: boolean;
    public shouldNavigateToHome: boolean;

    public constructor(
        public errorPageService: ErrorPageService,
        private translateService: TranslateService,
        private route: ActivatedRoute,
        private elcosService: ElcosService,
        private tmsService: TMSService,
        private titleService: TitleService,
        private routerService: RouterService,
    ) {}

    public ngOnInit(): void {
        this.loadOrangeElcos();
        this.errorType = this.route.snapshot.data['i18n'];
        const canRetryParam = this.route.snapshot.queryParams['canRetry'];
        this.canRetry = canRetryParam ? JSON.parse(canRetryParam) : false;
        // We should navigate to home whenever canRetry param is not set
        this.shouldNavigateToHome = !canRetryParam;
        this.confirmationLabel = this.getConfirmationLabel();
        const errorDefaultI18n = this.translateService.instant('ecm.error.default');
        switch (this.errorType) {
            case ErrorType.CUSTOM: {
                const customError = this.errorPageService.getError();
                this.error.title = customError.title ? customError.title : errorDefaultI18n['title'];
                this.error.description = customError.description
                    ? customError.description
                    : errorDefaultI18n['description'];
                break;
            }
            case ErrorType.NOT_FOUND:
                this.error.title = this.translateService.instant('ecm.error.not-found.title');
                this.error.description = this.translateService.instant('ecm.error.not-found.description');
                break;
            case ErrorType.DEFAULT:
            default:
                this.error.title = errorDefaultI18n['title'];
                this.error.description = errorDefaultI18n['description'];
        }
        this.titleService.setTitle(errorDefaultI18n['nav-title']);
        this.onAfterViewLoaded();
    }

    public confirm(): void {
        this.tmsService.trackLink({
            track_zone: 'service_indisponible',
            track_nom: this.canRetry ? 'reessayer' : 'retour_accueil',
            track_cible: this.canRetry ? window.location.href : `${window.location.origin}/accueil`,
        });
        if (this.canRetry) {
            window.location.reload();
        } else {
            this.routerService.navigateToHome();
        }
    }

    public onAfterViewLoaded(): void {
        this.tmsService.trackView({
            sous_univers: 'page_erreur_generique',
            univers_affichage: 'global',
            type_page: this.canRetry ? 'erreur_generique' : 'erreur_url',
            titre_page: 'service_indisponible',
            id_tracking: 'VlF1Vj9o',
        });
    }

    private loadOrangeElcos(): void {
        if (!this.elcosService.shown()) {
            this.elcosService.switchToOrange();
        }
    }

    private getConfirmationLabel(): string {
        if (!this.canRetry && !this.shouldNavigateToHome) {
            return undefined;
        }
        return this.canRetry
            ? this.translateService.instant('ecm.error.action.retry')
            : this.translateService.instant('ecm.error.action.home');
    }
}
